module.exports = __webpack_public_path__ + "static/media/thumbup.ca9c7c02.png";